import { channelNames } from '../../../../../../webSocket/channelNames';

/**
 * Returns whether to show the experience
 * @param {{
 *  showEncourageSellerReply: boolean,
 * }} message
 * @returns {boolean}
 */
export const shouldShow = (message) => !!message.showEncourageSellerReply;

/**
 * Returns whether the notification is an inbox realtime message
 * @param {{
 *  eventType: string
 * }} notification
 * @returns {boolean}
 */
export const isInboxRealtimeMessage = (notification) => notification.eventType === channelNames.INBOX_MESSAGES;
